// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__FpK77","container":"Footer_container__Y8RMM","links":"Footer_links__JUvvK"};